import { isNullOrUndefined } from './comparators'

const WATCH = 'watch'
const EMBED = 'embed'
const SHORT = 'youtu.be/'

export const getEmbedUrl = (youtubeUrl) => {
  try {
    if (isNullOrUndefined(youtubeUrl)) {
      return false
    }

    if (youtubeUrl.includes(EMBED)) {
      return youtubeUrl
    }

    if (youtubeUrl.includes(WATCH)) {
      return _generateEmbedUrl(_extractVideoId(youtubeUrl))
    }

    if (youtubeUrl.includes(SHORT)) {
      return _generateEmbedUrl(youtubeUrl.split(SHORT)[1])
    }

    return false
  } catch {
    return false
  }
}

const _generateEmbedUrl = (videoId) => {
  return `https://www.youtube.com/embed/${videoId}`
}

const _extractVideoId = (url) => {
  const params = JSON.parse(
    '{"' + url.split('?')[1].replace(/&/g, '","').replace(/=/g, '":"') + '"}',
    (key, value) => key === '' ? value : decodeURIComponent(value)
  )
  return params.v
}
